import { BillingStatus } from '../../enums';
import useVirtualDevice from '../devices/useVirtualDevice';
const useCanCreateMorePlots = (org) => {
    const { remainingVirtualDeviceActivations } = useVirtualDevice({ orgId: org?.id });
    return (org?.billingStatus !== BillingStatus.essential ||
        (org?.billingStatus === BillingStatus.essential && remainingVirtualDeviceActivations !== 0));
};
export default useCanCreateMorePlots;
